/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React from 'react'
import { Route, Switch } from 'react-router-dom'

import Settings from 'Containers/Settings'

import { settings } from '../../routes'

const SettingsComponents = () => (
  <Switch>
    <Route component={Settings} exact path={settings} />
    <Route component={Settings} exact path={`${settings}/:page`} />
  </Switch>
)

export default SettingsComponents
